import { ICustomPaymentParameters, IPaymentConditionMethodCode } from '@/interfaces/CustomPaymentParameters';

export default class CustomPaymentParameters implements ICustomPaymentParameters {
  offer_payment_condition_id: number;
  input_payment_condition_id: number;
  input_amount: number | null = null;
  main_payment_condition: IPaymentConditionMethodCode;
  second_payment_condition: IPaymentConditionMethodCode;

  constructor(customPaymentParameters?: ICustomPaymentParameters) {
    Object.assign(this, { ...customPaymentParameters });
  }
}
